import { JsonObject } from 'type-fest';

export const errorPages: JsonObject = {
  serviceUnavailable: {
    title: 'Ulepszamy nasz serwis!',
    subtitle: 'Właśnie wprowadzamy nowe funkcjonalności.\nWróć do nas później.',
  },
};
